import { industriesPPE } from '../config/ppeData';
import { ppeCategories } from '../config/ppeCategories';
import { supabase as supabaseClientUntyped } from '../lib/supabase';
import { SupabaseClient } from '@supabase/supabase-js';
import { Database } from '../types/database.types';
import { getPublicImageUrl } from '../config/storage';

const supabase: SupabaseClient<Database> = supabaseClientUntyped as SupabaseClient<Database>;

export const getAllPpeVisualizerImageUrls = (): string[] => {
  return industriesPPE.map(industry => {
    const { data } = supabase.storage
      .from('static-images')
      .getPublicUrl(`industry-selector/body-${industry.name.toLowerCase()}.jpg`);
    return data?.publicUrl || '/images/placeholder-product.jpg';
  }).filter(url => url !== '/images/placeholder-product.jpg');
};

// Función para obtener todas las URLs de imágenes de categorías EPP (formato jpg)
export const getAllEPPCategoryImageUrls = (): string[] => {
  return ppeCategories.map(category => {
    return getPublicImageUrl(`industry-selector/body-${category.id}.jpg`, true);
  });
};

// Función para precargar una lista de imágenes en segundo plano con decodificación GPU/RAM
export const preloadImages = (urls: string[]): void => {
  const load = () => {
    urls.forEach(url => {
      const img = new Image();
      img.src = url;
      if ('decode' in img) {
        img.decode().catch(() => {});
      }
    });
  };

  if ('requestIdleCallback' in window) {
    (window as any).requestIdleCallback(load);
  } else {
    setTimeout(load, 300);
  }
};

// Función para precargar imágenes con promesas para mejor control
export const preloadImagesWithPromises = (urls: string[]): Promise<void[]> => {
  const preloadPromises = urls.map(url => {
    return new Promise<void>((resolve) => {
      const img = new Image();
      img.onload = () => {
        if ('decode' in img) {
          img.decode().then(resolve).catch(() => resolve());
        } else {
          resolve();
        }
      };
      img.onerror = () => resolve();
      img.src = url;
    });
  });

  return Promise.all(preloadPromises);
};